import React from "react";
import Spinner from "react-bootstrap/Spinner";

function CustomSpinner(props) {
  const { animationType, spinnerSize } = props;
  return <Spinner animation={animationType} role="status" size={spinnerSize} />;
}

export default CustomSpinner;
